import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { setFirstName, setLastName } from "../../../redux/slices/authSlice";
import InputField from "../../../components/InputField";
import AuthCard from "../../../components/AuthCard";
import Button from "../../../components/Button";
import FormGroup from "../../../components/FormGroup";
import RequiredLabel from "../../../components/RequiredLabel";

export default function AddUserName() {
  const [first, setFirst] = useState("");
  const [last, setLast] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const isFormValid = first.trim() !== "" && last.trim() !== "";
  const requiredReason = t("pleaseCompleteRequiredFields", {
    defaultValue: "Please complete all required fields correctly.",
  });

  const handleNext = () => {
    if (!isFormValid) return;
    dispatch(setFirstName(first));
    dispatch(setLastName(last));
    navigate("/auth/terms");
  };

  return (
    <div className="flex flex-col items-center justify-center h-screen bg-gray-50 animate-fade-in">
      <AuthCard>
        <h2 className="sub-header mb-4">{t('yourName')}</h2>
        <FormGroup>
          <RequiredLabel htmlFor="first-name" className="mb-2">
            {t("firstName")}
          </RequiredLabel>
          <InputField
            id="first-name"
            placeholder={t('firstName')}
            value={first}
            onChange={(e) => setFirst(e.target.value)}
            required
          />
        </FormGroup>
        <FormGroup>
          <RequiredLabel htmlFor="last-name" className="mb-2">
            {t("lastName")}
          </RequiredLabel>
          <InputField
            id="last-name"
            placeholder={t('lastName')}
            value={last}
            onChange={(e) => setLast(e.target.value)}
            required
          />
        </FormGroup>
        <Button
          onClick={handleNext}
          className="w-full mt-4"
          disabled={!isFormValid}
          disabledReason={!isFormValid ? requiredReason : ""}
        >
          {t('next')}
        </Button>
      </AuthCard>
    </div>
  );
}
